import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Button, Form, Input, Menu, Radio, Row, Spin } from "antd";
import AWS from "aws-sdk";

// import {setReduxChannel} from "../../redux/store/channel/channelDuck";
// import CategoryRelationShip from "./category/CategoryRelationShip";
import Swal from "sweetalert2";

import categoryApi from "../../apis/Category.api";
import partnersApi from "../../apis/Partners.api";
import { setLoading } from "../../redux/store/common/commonDuck";
import { toastAlert } from "../AlertComponent";

import CategoryAddComponent from "./category/CategoryAddComponent";
import EditLinkComponent from "./category/EditLinkComponent";
import EditProductComponent from "./category/EditProductComponent";

AWS.config.update({
	accessKeyId: process.env.REACT_APP_S3_ACCESSKEYID,
	secretAccessKey: process.env.REACT_APP_S3_SECRETACCESSKEY,
	region: process.env.REACT_APP_S3_REGION,
});

const s3 = new AWS.S3();
const EditIngredients = ({ getInfo }) => {
	const dispatch = useDispatch();
	const user = useSelector((state) => state.auth.user);
	// const reduxChannel = useSelector(state => state.channel.reduxChannel);
	// const setChannel = (value) => dispatch(setReduxChannel(value));

	const isLoading = useSelector((state) => state.common.loading);
	const setIsLoading = (value) => dispatch(setLoading(value));

	const [selectKey, setSelectKey] = useState({});
	const [linkList, setLinkList] = useState([]);
	const [productList, setProductList] = useState([]);
	const [ingredientList, setIngredientList] = useState([]);
	const [functionList, setFunctionList] = useState([]);
	const [selectRelationList, setSelectRelationList] = useState([]);
	const [isShow, setIsShow] = useState(1);
	const [mainTag, setMainTag] = useState(0);

	const [categoryObj, setCategoryObj] = useState({
		category_id: "",
		category_name: "",
		description: "성분별",
	});

	const [newCategoryList, setNewCategoryList] = useState([]);

	useEffect(() => {
		getCategory();
		categoryAllInfluencer();
		return () => {
			setIsLoading(false);
		};
	}, []);

	useEffect(() => {
		if (selectKey.id) {
			// 노출/미노출
			if (typeof selectKey.is_show === "boolean") {
				setIsShow(selectKey.is_show ? 1 : 0);
			}
			// 관련 고민/성분
			let list = [];
			if (selectKey.function_list?.length) {
				list = selectKey.function_list?.split(",");
			}
			if (list?.length) {
				let checkedBySelect = functionList.filter((item) =>
					list.includes(String(item.id))
				);
				setSelectRelationList(checkedBySelect);
			} else {
				setSelectRelationList([]);
			}
			if (selectKey.is_hot) {
				setMainTag(1);
			}
			if (selectKey.is_best) {
				setMainTag(2);
			}
			if (!selectKey.is_hot && !selectKey.is_best) {
				setMainTag(0);
			}
		} else {
			setSelectRelationList([]);
		}
	}, [selectKey]);

	/**
	 * 카테고리 리스트 가져오기
	 * @returns {Promise<void>}
	 */
	const categoryAllInfluencer = async () => {
		let param = {
			influencer_id: user?.id,
		};
		const res = await categoryApi.getAllCategory(param);
		if (res.code === 200) {
			setNewCategoryList([...res.result]);
		} else {
			setNewCategoryList([]);
		}
	};

	/**
	 * ingredientList, functionList 가져오기
	 * @param type
	 * @returns {Promise<void>}
	 */
	const getCategory = async (type) => {
		setIsLoading(true);
		let param = {
			influencerId: user.id,
		};

		const res = await partnersApi.readCategoryList(param);
		if (res.code === 200) {
			setIngredientList(res.result.totalIngredientList);
			setFunctionList(res.result.functionList);
			if (type === "save") {
				Swal.fire({
					customClass: "alert-custom",
					text: "성공적으로 저장되었습니다!",
					confirmButtonText: "확인",
				}).then(() => {
					addNewCategory();
				});
			} else if (type === "edit") {
				Swal.fire({
					customClass: "alert-custom",
					text: "성공적으로 수정되었습니다!",
					confirmButtonText: "확인",
				}).then(() => {});
				// addNewCategory();
			} else if (type === "delete") {
				Swal.fire({
					customClass: "alert-custom",
					text: "성공적으로 삭제되었습니다!",
					confirmButtonText: "확인",
				}).then(() => {
					addNewCategory();
				});
			}
		}
		setIsLoading(false);
	};

	/**
	 * 저장 add/수정 edit
	 * @returns {Promise<void>}
	 */
	const submitList = async (type) => {
		let isValid = false; // true: 오류, false: 통과
		for (let i = 0; i < linkList.length; i++) {
			// 타이틀 x || 길이 === 0 // true: 오류, false: 통과
			let titleValid = !!(
				!linkList[i]?.title || linkList[i]?.title?.length === 0
			);
			// url x || https x || https://[길이 === 0] // true: 오류, false: 통과
			let urlValid = !!(
				!linkList[i]?.url ||
				!linkList[i]?.url?.includes("https") ||
				linkList[i]?.url?.split("https://")[1]?.length === 0
			);

			if (titleValid || urlValid) {
				if (!isValid) {
					isValid = true;
				}
			}
		}
		if (!selectKey.ingredient_id && !categoryObj.category_id) {
			if (!isValid) {
				isValid = true;
			}
		}
		if (isValid) {
			toastAlert("해당하는 내용을 모두 입력해주세요.");
		} else {
			Swal.fire({
				customClass: "alert-custom",
				text: `${type === "add" ? "저장" : "수정"}하시겠습니까?`,
				showCancelButton: true,
				confirmButtonText: "확인",
				cancelButtonText: "취소",
			}).then(async (result) => {
				if (result.isConfirmed) {
					setIsLoading(true);
					let list = [];
					for (let i = 0; i < linkList.length; i++) {
						let linkId = linkList[i]?.id ?? null;
						let url = linkList[i]?.url;
						let listEach = {
							platform_id: url?.includes("instagram") ? 5 : 0,
							platform_name: url?.includes("instagram")
								? "instagram"
								: "Youtube",
							url: linkList[i].url,
							title: linkList[i].title,
							search_tag: linkList[i].search_tag,
						};
						if (linkId !== null) {
							listEach = { ...listEach, id: linkId };
						}
						list.push(listEach);
					}
					// 상품 우선순위
					for (let i = 0; i < productList.length; i++) {
						productList[i].sort_order = i + 1;
					}

					let param = {
						influencer_id: user.id,
						category_id: selectKey.ingredient_id
							? selectKey.ingredient_id
							: categoryObj.category_id,
						category_name: categoryObj.category_name,
						category_type: "ingredient",
						updated_by: user.id,
						associatedVideoList: list,
						productList: productList,
						associatedFunctionList: selectRelationList,
						is_show: isShow === 1,
						explanation: selectKey?.explanation ?? null,
						is_hot: mainTag === 1,
						is_best: mainTag === 2,
						// caution: "",
						// tag: "",
					};

					let res = { code: 0, result: {} };
					if (type === "add") {
						res = await partnersApi.createCategoryList(param);
					} else {
						res = await partnersApi.postCategoryLinkList(param);
					}
					if (res.code === 200) {
						let list = res.result;
						for (let i = 0; i < list.length; i++) {
							let addObj = {
								...list[i],
								...productList[i],
							};
							// edit
							if (addObj.id) {
								if (addObj?.photo) {
									const rsq = await partnersApi.updateCategoryProduct({
										...addObj,
										updated_by: user?.id,
									});
									if (rsq.code === 200) {
										console.log("edit");
										uploadToS3(addObj);
									}
								} else {
									console.log("no-edit");
								}
							}
							// save
							else {
								const rsq = await partnersApi.createCategoryProduct({
									...addObj,
									created_by: user?.id,
								});
								if (rsq.code === 200) {
									console.log("save");
									uploadToS3(addObj);
								}
							}
						}
						getCategory(type === "add" ? "save" : "edit");
					} else {
						setIsLoading(false);
					}
				}
			});
		}
	};

	/**
	 * 이미지 S3 업로드
	 * @param reviewId
	 */
	const uploadToS3 = async (addObj) => {
		let id = addObj.id;
		let fileType = addObj?.photo?.type.split("/")[1] ?? addObj.img_type;
		let s3Path = `image/together/${user.influencer_id}/${id}.${fileType}`;
		console.log(id, fileType, s3Path);
		//aws-sdk 사용
		let params = {
			Bucket: process.env.REACT_APP_S3_BUCKETNAME,
			Key: s3Path,
			Body: addObj?.photo?.file,
		};

		let res = await s3.putObject(params).promise();

		if (res.$response.httpResponse.statusCode === 200) {
			// alert("정상적으로 저장되었습니다.");
			// getInfo();
		} else {
			alert("이미지 업로드 오류");
		}
		// getProductList(selectKey);
		// setModalShow(false);
	};

	/**
	 * 해당 카테고리 표기 수정
	 * @returns {Promise<void>}
	 */
	// const submitMenuEdit = async (value) => {
	//     setIsLoading(true);
	//     let param = {
	//         id: user.id,
	//         ingredient_menu_show: value,
	//         function_menu_show: reduxChannel?.function_menu_show,
	//         combination_menu_show: reduxChannel?.combination_menu_show,
	//         quick_menu_show: reduxChannel?.quick_menu_show,
	//         updated_by: user.id,
	//     }
	//     const res = await partnersApi.editMenuChannel(param);
	//     if (res.code === 200) {
	//         getInfo();
	//         setChannel({
	//             ...reduxChannel,
	//             param
	//         })
	//     }
	//     setIsLoading(false);
	// }

	/**
	 * 카테고리 새로 생성
	 */
	const addNewCategory = () => {
		setSelectKey({});
		setLinkList([]);
		setProductList([]);
		setCategoryObj({
			category_id: "",
			category_name: "",
			description: "성분별 카테고리",
		});
	};

	/**
	 * 해당 카테고리 삭제
	 * @returns {Promise<void>}
	 */
	const deleteCategory = async () => {
		if (selectKey?.id) {
			Swal.fire({
				customClass: "alert-custom",
				text: `해당 카테고리를 삭제하시겠습니까?`,
				showCancelButton: true,
				confirmButtonText: "확인",
				cancelButtonText: "취소",
			}).then(async (result) => {
				if (result.isConfirmed) {
					setIsLoading(true);
					let param = {
						categoryId: selectKey.id,
						categoryType: "ingredient",
						userId: user?.id,
					};
					const res = await partnersApi.deleteCategoryList(param);
					if (res.code === 200) {
						getCategory("delete");
					} else {
						setIsLoading(false);
					}
				}
			});
		}
	};

	return (
		<div className={`channel-edit-component`}>
			<div className={`channel-edit-category-wrap`}>
				<div className={`edit-channel-category`}>
					<div className={`edit-channel-category-title`}>
						{/*<Button>성분별</Button>*/}
						{/*<Button>고민별</Button>*/}
						{/*<Button>조합별</Button>*/}
						성분별 카테고리
					</div>
					<Menu
						className={`edit-channel-category-body`}
						selectedKeys={[`${selectKey.ingredient_id}`]}
					>
						{isLoading ? (
							<Spin
								style={{ margin: "auto", width: "100%", paddingTop: "2em" }}
							/>
						) : (
							<>
								{ingredientList?.length > 0 ? (
									<>
										{ingredientList?.map((item, idx) => (
											<Menu.Item
												key={`${item?.ingredient_id}`}
												id={`${item?.ingredient_id} ${idx}`}
												onClick={() => setSelectKey(item)}
											>
												{item.ingredient_name}
											</Menu.Item>
										))}
									</>
								) : (
									<Row
										align={"middle"}
										style={{
											width: "100%",
											flexDirection: "column",
											padding: "3em 0",
										}}
									>
										<img
											src={`/assets/images/warning.png`}
											alt={`warning-icon`}
											style={{
												width: "3em",
												height: "auto",
											}}
										/>
										<span
											style={{
												marginTop: "1em",
												color: "#adb5bd",
												fontSize: "1.1em",
												fontWeight: 500,
											}}
										>
											등록된 카테고리가 없습니다.
										</span>
									</Row>
								)}
							</>
						)}
					</Menu>
					<div
						className={`edit-channel-category-footer`}
						onClick={addNewCategory}
					>
						<img
							src={`/assets/images/channel/combination.png`}
							alt={`성분별 카테고리 목록 추가`}
							style={{
								width: 13,
								height: 13,
							}}
						/>
						성분별 카테고리 목록 추가
					</div>
				</div>

				{Object.keys(selectKey).length ? (
					<div className={`category-setup-div`}>
						{/* 타이틀 : 카테고리 설정 */}
						<div
							className={`category-setup-each`}
							style={{ display: "flex", justifyContent: "space-between" }}
						>
							<p
								className={`category-setup-title`}
								style={{ fontSize: "1.5em", width: "fit-content" }}
							>
								카테고리 설정
							</p>
							<Button
								size={`small`}
								className={`delete-btn`}
								onClick={deleteCategory}
								loading={isLoading}
							>
								해당 카테고리 삭제
							</Button>
						</div>

						{/* 카테고리명/카테고리 설명 */}
						<Form
							layout={`horizontal`}
							labelCol={{ span: 5 }}
							autoComplete="off"
							className={`category-setup-each-form`}
						>
							{/* 카테고리 노출 */}
							<Form.Item
								label={`노출/미노출`}
								labelAlign="left"
								colon={false}
								className={`category-setup-form-title`}
								wrapperCol={{ span: 14 }}
							>
								<Radio.Group
									defaultValue={isShow ?? 1}
									value={isShow}
									onChange={(e) => setIsShow(e.target.value)}
									disabled={isLoading}
								>
									<Radio value={1}>노출</Radio>
									<Radio value={0}>미노출</Radio>
								</Radio.Group>
							</Form.Item>

							{/* 중요 태그 */}
							<Form.Item
								label={`중요 태그`}
								labelAlign="left"
								colon={false}
								className={`category-setup-form-title`}
								wrapperCol={{ span: 14 }}
							>
								<Radio.Group
									// defaultValue={isShow ?? 1}
									value={mainTag}
									onChange={(e) => {
										setMainTag(e.target.value);
									}}
									disabled={isLoading}
								>
									<Radio value={0}>일반</Radio>
									<Radio value={1}>HOT(1순위)</Radio>
									<Radio value={2}>BEST(2순위)</Radio>
								</Radio.Group>
							</Form.Item>

							{/* 카테고리명 */}
							<Form.Item
								label={`카테고리명`}
								labelAlign="left"
								colon={false}
								className={`category-setup-form-title`}
								wrapperCol={{ span: 7 }}
							>
								<Input
									type={`text`}
									name={`ingredient-name`}
									className={`ingredient-name`}
									disabled={true}
									value={selectKey?.ingredient_name}
								/>
							</Form.Item>

							{/* 카테고리 설명 */}
							<Form.Item
								label={`연관 고민`}
								labelAlign="left"
								colon={false}
								className={`category-setup-form-title`}
								wrapperCol={{ span: 14 }}
							>
								<Input
									type={`text`}
									name={`ingredient-name`}
									className={`ingredient-name`}
									disabled={true}
									value={selectRelationList?.map((item) => item.function_name)}
								/>
							</Form.Item>

							{/* 카테고리 설명 */}
							{/*<Form.Item*/}
							{/*    label={`카테고리 설명`}*/}
							{/*    labelAlign="left"*/}
							{/*    colon={false}*/}
							{/*    className={`category-setup-form-title`}*/}
							{/*    wrapperCol={{span: 14}}*/}
							{/*>*/}
							{/*    <Input*/}
							{/*        type={`text`}*/}
							{/*        name={`ingredient-name`}*/}
							{/*        className={`ingredient-name`}*/}
							{/*        disabled={true}*/}
							{/*        value={selectKey?.tag}*/}
							{/*    />*/}
							{/*</Form.Item>*/}

							{/* 성분 설명 */}
							<Form.Item
								label={`성분 설명`}
								labelAlign="left"
								colon={false}
								className={`category-setup-form-title`}
								wrapperCol={{ span: 14 }}
							>
								<Input.TextArea
									type={`text`}
									name={`ingredient-name`}
									className={`ingredient-name`}
									placeholder={`성분에 대한 설명을 입력해주세요.`}
									value={selectKey?.explanation}
									onChange={(e) => {
										setSelectKey({
											...selectKey,
											explanation: e.currentTarget.value,
										});
									}}
									style={{
										minHeight: "8em",
									}}
								/>
							</Form.Item>
						</Form>

						{/* 관련 성분/고민 추가 */}
						{/*<CategoryRelationShip*/}
						{/*    type={"ingredient"}*/}
						{/*    relationList={functionList}*/}
						{/*    selectRelationList={selectRelationList}*/}
						{/*    setSelectRelationList={setSelectRelationList}*/}
						{/*/>*/}

						{/* 관련 영상 추가 */}
						<EditLinkComponent
							selectKey={selectKey}
							linkList={linkList}
							setLinkList={setLinkList}
						/>

						{/* 관련 영양제 */}
						<EditProductComponent
							selectKey={selectKey}
							productList={productList}
							setProductList={setProductList}
							level={"ingredient"}
						/>
					</div>
				) : (
					<CategoryAddComponent
						selectKey={selectKey}
						newCategoryList={newCategoryList}
						categoryObj={categoryObj}
						setCategoryObj={setCategoryObj}
						linkList={linkList}
						setLinkList={setLinkList}
						productList={productList}
						setProductList={setProductList}
						relationList={functionList}
						type={"ingredient"}
						selectRelationList={selectRelationList}
						setSelectRelationList={setSelectRelationList}
					/>
				)}
			</div>
			<div className={`edit-category-footer`}>
				{Object.keys(selectKey).length ? (
					<Button onClick={() => submitList("edit")} loading={isLoading}>
						적용하기
					</Button>
				) : (
					<Button onClick={() => submitList("add")} loading={isLoading}>
						저장하기
					</Button>
				)}
			</div>
		</div>
	);
};

export default EditIngredients;
